//
//
//
//
//
//
//
import includes from 'lodash/includes';
import NcsDownloadMixin from './NcsDownloadMixin';
export default {
  mixins: [NcsDownloadMixin],
  computed: {
    visible: function visible() {
      return includes(this.$ncsConfig.app.allow_download_for, this.currentResultType);
    }
  },
  methods: {
    download: function download() {
      var downloadConfig = this.$ncsConfig.download[this.currentResultType];
      this.downloadAction('api/executeDownload', downloadConfig.filename, 'download');
    }
  }
};